<script>

    import { userStore } from '../stores'
    import { toast } from 'bulma-toast'

    import ShipmentsService from '../$services/shipments.service'
    import DateMethod from '../$methods/date.method'

    import Form from '../$components/form.svelte'
    import Date from '../$components/date.svelte'
    import Button from '../$components/button.svelte'
    import SelectUsers from '../$components/select.users.svelte'
    import SelectProviders from '../$components/select.providers.svelte'

    export let all = false

    let data = {}
    let loading = false
    let element

    async function getShipmentsReport() {

        if(all === false)
            data.userId = $userStore._id
        else
            data.all = true

        loading = true
        const blob = await ShipmentsService.getShipmentsReport(data)
        loading = false

        if(!blob)
            return toast({message: 'Error al descargar el reporte', type: 'is-danger'})

        let fileName = !all ? `${ $userStore.email }_` : 'envios_'
            fileName += `${ DateMethod.dateShort(data.dateStart) }_${ DateMethod.dateShort(data.dateEnd) }`

        element.download = `${fileName}.csv`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<style>
    .all {
        margin-top: 100px;
        margin-bottom: 100px;
    }
</style>

<a bind:this={element} style="display: none;" href="/">.</a>

<div class:all={all}>
    <div class="title">Reporte de envíos</div>

    <Form on:submit={getShipmentsReport} { loading }>
        <div class="columns">
            <div class="column">
                <SelectUsers bind:userId={data.userId} role="user" required={false} />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <SelectProviders bind:provider={data.provider} />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <Date label="Fecha de inicio" bind:value={data.dateStart} />
            </div>
            <div class="column">
                <Date label="Fecha final" bind:value={data.dateEnd} />
            </div>
        </div>

        <div class="items-end">
            <Button type="submit" text="Descargar" icon="save" color="primary" { loading } />
        </div>
    </Form>
</div>
